import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const CountdownTimer = ({ targetDate, title, onComplete }) => {
  const { t } = useTranslation();

  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      if (onComplete) onComplete(); // Appeler la callback quand le compteur est fini
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }); // Pas de tableau de dépendances pour se ré-exécuter à chaque render et mettre à jour

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval] && timeLeft[interval] !== 0) { // Ne pas afficher si 0 et non la dernière seconde
      return;
    }
    timerComponents.push(
      <div key={interval} className="text-center p-2 md:p-3 bg-slate-700/50 dark:bg-slate-800/60 rounded-lg shadow-md min-w-[60px] md:min-w-[70px]">
        <span className="text-2xl md:text-3xl font-bold text-primary-400 dark:text-primary-300">
          {String(timeLeft[interval]).padStart(2, '0')}
        </span>
        <span className="block text-xs md:text-sm text-slate-400 dark:text-slate-500 uppercase">
          {t(`countdown.${interval}`)} {/*  Ex: countdown.days, countdown.hours */}
        </span>
      </div>
    );
  });

  const isEnded = useMemo(() => Object.keys(timeLeft).length === 0, [timeLeft]);

  return (
    <div className="my-4">
      <h3 className="text-xl font-semibold text-slate-100 dark:text-slate-200 mb-3 text-center">{title}</h3>
      {isEnded ? (
        <p className="text-center text-2xl font-bold text-green-400 dark:text-green-300 py-4">
          {t('countdown.launched')} {/* Ex: countdown.launched -> "Lancé !" */}
        </p>
      ) : (
        <div className="flex justify-center space-x-2 md:space-x-3">
          {timerComponents.length ? timerComponents : <p className="text-slate-400">{t('countdown.calculating')}</p>}
        </div>
      )}
    </div>
  );
};

export default CountdownTimer;
